// extracted by mini-css-extract-plugin
export default {"wrapper":"XWscIv9oCXNQliJ3vgJd","header":"Zw1ktfgilUfDjB2O8pVM","main":"N8i6649T74ogVSU9LxPq"};